/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量3
 * @export
 * @interface Col3
 */
export interface Col3 {
}

/**
 * Check if a given object implements the Col3 interface.
 */
export function instanceOfCol3(value: object): value is Col3 {
    return true;
}

export function Col3FromJSON(json: any): Col3 {
    return Col3FromJSONTyped(json, false);
}

export function Col3FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col3 {
    return json;
}

export function Col3ToJSON(json: any): Col3 {
    return Col3ToJSONTyped(json, false);
}

export function Col3ToJSONTyped(value?: Col3 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

